import { Grid } from "@mui/material";
import ByzOfficesList from "src/components/shared-components/ByzOfficesList";

interface Props {
  onChange: (value: any) => void;
}

export default function OfficesFilter({ onChange }: Props) {
  return (
    <Grid item xs={12} sm={6} md={2}>
      <ByzOfficesList handleChange={onChange} />
    </Grid>
  );
}
